import type { Locale } from '@change-corgi/config/locales';

import webappInfo from '#src/webappInfo';

export function getServerTranslationsUrl(locale: Locale, cacheBuster?: string): string {
	return `/${webappInfo.name}/i18n/${locale}.json${cacheBuster ? `?${cacheBuster}` : ''}`;
}
